import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Body = styled.div`
  padding: ${space[3]} ${space[4]} ${space[5]};
  display: flex;
  flex-direction: column;
  gap: ${space[5]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[5]} ${space[7]};
  }
`;

export const RecommendationsHeading = styled.p`
  margin: 0;
  text-align: center;
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.normal};
  font-size: ${fonts.size['2xl']};
  line-height: 1.2;
  color: ${colors.fontPrimary};
`;

export const RecommendationsHeadingSecondary = styled.span`
  color: ${colors.fontSecondary};
`;

export const ActionBar = styled.div`
  display: flex;
  gap: ${space[3]};
  padding: ${space[4]};
  background: ${colors.white};
  border-top: 1px solid ${colors.borderGreyLighter};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[5]} ${space[7]};
  }
`;
